export default __webpack_public_path__ + "static/media/Zahra_Mertens_Resume.d20f2a4d.pdf";